module.exports = __webpack_public_path__ + "img/fachadaisa2(1).5fd8eb0f.png";